'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('justifyContent', 'justify');


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/justify-content.js
// module id = 4368
// module chunks = 168707334958949